class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    console.log('[DEBUG] renderPage called with searchParams:', searchParams);
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    console.log('[DEBUG] Sections to update:', sections);
    
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    
    const productGrid = document.getElementById('ProductGridContainer');
    console.log('[DEBUG] ProductGridContainer:', productGrid);
    if (productGrid) {
      const collection = productGrid.querySelector('.collection');
      console.log('[DEBUG] Collection element:', collection);
      if (collection) collection.classList.add('loading');
    }
    
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      console.log('[DEBUG] Fetching URL:', url);
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    console.log('[DEBUG] renderSectionFromFetch:', url);
    fetch(url)
      .then((response) => {
        console.log('[DEBUG] Fetch response:', response.status, response.ok);
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        return response.text();
      })
      .then((responseText) => {
        console.log('[DEBUG] Got response text, length:', responseText.length);
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      })
      .catch((error) => {
        console.error('[DEBUG] Fetch error:', error);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    console.log('[DEBUG] renderProductGridContainer called');
    const productGridContainer = document.getElementById('ProductGridContainer');
    
    const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
    const newProductGridContainer = parsedHtml.getElementById('ProductGridContainer');
    
    if (!newProductGridContainer) {
      console.error('[DEBUG] ERROR: ProductGridContainer not found in response HTML');
      return;
    }
    
    // DEBUG: Log product titles and prices to verify sort order
    const products = newProductGridContainer.querySelectorAll('.card__heading');
    console.log('[DEBUG] Products in response:');
    products.forEach((p, i) => {
      const price = p.closest('.grid__item')?.querySelector('.price')?.textContent?.trim() || 'no price';
      console.log(`  ${i + 1}. ${p.textContent.trim()} - ${price}`);
    });
    
    productGridContainer.innerHTML = newProductGridContainer.innerHTML;
    
    // Remove loading class from collection element
    const collection = productGridContainer.querySelector('.collection');
    if (collection) {
      collection.classList.remove('loading');
    }

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
    console.log('[DEBUG] ProductGridContainer updated');
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;

      // Synchronize checkbox checked states after outerHTML replacement
      // This ensures the visual highlight matches the selected filters on desktop
      const newWrapElement = target.querySelector('.facets-wrap');
      if (newWrapElement) {
        newWrapElement.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
          checkbox.checked = checkbox.hasAttribute('checked');
        });
      }
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    const productGrid = document.getElementById('product-grid');
    console.log('[DEBUG] getSections - product-grid element:', productGrid);
    if (!productGrid) {
      console.error('[DEBUG] ERROR: product-grid element not found!');
      return [];
    }
    console.log('[DEBUG] getSections - dataset.id:', productGrid.dataset.id);
    return [
      {
        section: productGrid.dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

// Sort Dropdown Manager - uses event delegation for dynamic content
window.SortDropdownManager = {
  initialized: false,
  
  init() {
    if (this.initialized) return;
    this.initialized = true;
    
    // Use event delegation for sort dropdown interactions
    document.addEventListener('click', (event) => {
      // Handle mobile sort option click - close with animation
      const mobileSortOption = event.target.closest('.mobile-sort-option');
      if (mobileSortOption) {
        closeMobileSortSheet();
        return;
      }
      
      // Handle desktop sort dropdown
      const dropdown = event.target.closest('custom-sort-dropdown');
      
      if (!dropdown) {
        // Click outside any dropdown - close all dropdowns
        this.closeAllDropdowns();
        return;
      }
      
      // Click inside a dropdown - handle the specific element clicked
      const trigger = event.target.closest('.sort-icon-trigger');
      const option = event.target.closest('.sort-dropdown-option');
      
      if (trigger) {
        this.toggleDropdown(dropdown);
      } else if (option) {
        this.selectOption(dropdown, option);
      }
    });
    
    // Close on escape key
    document.addEventListener('keydown', (event) => {
      if (event.code === 'Escape') {
        this.closeAllDropdowns();
        // Also close mobile sort sheet on Escape with animation
        const mobileSortSheet = document.getElementById('MobileSortSheet');
        if (mobileSortSheet && !mobileSortSheet.hidden) {
          closeMobileSortSheet();
        }
      }
    });
  },
  
  toggleDropdown(dropdown) {
    const trigger = dropdown.querySelector('.sort-icon-trigger');
    const menu = dropdown.querySelector('.sort-dropdown-menu');
    
    if (!trigger || !menu) return;
    
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
    
    // Close other dropdowns first
    this.closeAllDropdowns();
    
    // Toggle current
    trigger.setAttribute('aria-expanded', !isExpanded);
    menu.hidden = isExpanded;
  },
  
  closeAllDropdowns() {
    document.querySelectorAll('custom-sort-dropdown').forEach((dropdown) => {
      const trigger = dropdown.querySelector('.sort-icon-trigger');
      const menu = dropdown.querySelector('.sort-dropdown-menu');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (menu) menu.hidden = true;
    });
  },
  
  closeDropdown(dropdown) {
    const trigger = dropdown.querySelector('.sort-icon-trigger');
    const menu = dropdown.querySelector('.sort-dropdown-menu');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (menu) menu.hidden = true;
  },
  
  selectOption(dropdown, selectedOption) {
    const value = selectedOption.dataset.value;
    const hiddenInput = dropdown.closest('form')?.querySelector('input[name="sort_by"]');
    const options = dropdown.querySelectorAll('.sort-dropdown-option');
    
    // Update hidden input
    if (hiddenInput) {
      hiddenInput.value = value;
    }
    
    // Update visual active state for all options
    options.forEach((option) => {
      const isSelected = option.dataset.value === value;
      option.classList.toggle('is-active', isSelected);
      option.setAttribute('aria-current', isSelected ? 'true' : 'false');
      
      // Add or remove checkmark
      let checkmark = option.querySelector('.sort-check');
      if (isSelected && !checkmark) {
        checkmark = document.createElement('span');
        checkmark.className = 'sort-check';
        checkmark.textContent = '✓';
        option.insertBefore(checkmark, option.firstChild);
      } else if (!isSelected && checkmark) {
        checkmark.remove();
      }
    });
    
    this.closeDropdown(dropdown);
    
    // Trigger form submission
    if (hiddenInput) {
      hiddenInput.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
};

// Function to close mobile sort sheet with animation
function closeMobileSortSheet() {
  const sheet = document.getElementById('MobileSortSheet');
  const trigger = document.querySelector('.mobile-sort-trigger');
  
  if (!sheet) return;
  
  // Add closing class to trigger animation
  sheet.classList.add('closing');
  
  // Wait for animation to finish, then actually hide
  setTimeout(() => {
    sheet.hidden = true;
    sheet.classList.remove('closing');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }, 300); // Match animation duration
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => window.SortDropdownManager.init());
} else {
  window.SortDropdownManager.init();
}
